/**
 * 天地图组件常量配置
 */

/**
 * 绘制模式下的多边形样式配置
 * 用于用户正在绘制多边形时的视觉效果
 */
export const DRAW_POLYGON_OPTIONS = {
  /** 边框颜色 */
  color: '#2254f4',
  /** 边框宽度 */
  weight: 2,
  /** 边框不透明度 */
  opacity: 1,
  /** 填充颜色 */
  fillColor: '#2254f4',
  /** 填充不透明度 */
  fillOpacity: 0.2
}

/**
 * 展示模式下的多边形样式配置
 * 用于多边形绘制完成后的显示效果
 */
export const SHOW_POLYGON_OPTIONS = {
  /** 边框颜色 */
  color: '#ff2429',
  /** 边框宽度 */
  weight: 2,
  /** 边框不透明度 */
  opacity: 1,
  /** 填充颜色 */
  fillColor: '#ff2429',
  /** 填充不透明度 */
  fillOpacity: 0.4
}
